import React, { useState } from "react";
import "./Faqs.css"; // ✅ separate CSS file

export default function FaqSection() {
  // Astrology-based FAQ data
  const faqs = [
    {
      id: "f1",
      q: "How can astrology help me in making life decisions?",
      a: "Astrology helps you understand your natural strengths, challenges, and timing of opportunities. It offers guidance on career, love, and health by aligning your actions with favorable planetary periods."
    },
    {
      id: "f2",
      q: "Are online horoscope readings accurate?",
      a: "Accuracy depends on providing your correct birth date, time, and location. Our astrologers use advanced charts and calculations to ensure authentic and precise readings."
    },
    {
      id: "f3",
      q: "Can astrology predict marriage or relationship timing?",
      a: "Yes. Using your birth chart, astrologers can analyze planetary influences like Venus, Jupiter, and the 7th house to identify ideal periods for marriage and relationship growth."
    },
    {
      id: "f4",
      q: "What if I don’t know my exact birth time?",
      a: "Don’t worry — through a process called ‘Birth Time Rectification,’ astrologers can estimate your accurate birth time based on key life events you provide."
    },
    {
      id: "f5",
      q: "Can astrology help improve my health and wellbeing?",
      a: "Absolutely. Planetary placements can indicate health tendencies. Remedies like gemstones, mantras, or lifestyle changes are suggested to balance energies for better health."
    },
    {
      id: "f6",
      q: "Do remedies like gemstones and mantras really work?",
      a: "Yes — when prescribed correctly by a qualified astrologer. They help align your personal energy with planetary vibrations and remove blockages that affect progress."
    },
    {
      id: "f7",
      q: "Is astrology compatible with modern science?",
      a: "Astrology complements modern science by focusing on timing, personality, and energy patterns rather than replacing empirical methods. Many find it a spiritual guide for self-awareness."
    }
  ];

  const [openIds, setOpenIds] = useState(new Set(["f1", "f3"])); // default open

  const toggle = (id) => {
    const newOpenIds = new Set(openIds);
    if (newOpenIds.has(id)) newOpenIds.delete(id);
    else newOpenIds.add(id);
    setOpenIds(newOpenIds);
  };

  const isOpen = (id) => openIds.has(id);

  return (
    <section className="faq-section" aria-labelledby="faq-title">
      <div className="wrap">
        <header className="faq-header">
          <h1 id="faq-title" className="title">
            Frequently Asked Questions
          </h1>
          <div className="eyebrow">
            <span className="eyebrow-bar"></span>
            <span className="eyebrow-text">Astro FAQ</span>
          </div>
        </header>

        <div className="faq-grid">
          {/* Left column */}
          <div className="col">
            {faqs.slice(0, 3).map((item) => (
              <div key={item.id} className="faq-card">
                <div
                  className="faq-toggle"
                  onClick={() => toggle(item.id)}
                  tabIndex="0"
                  role="button"
                  aria-expanded={isOpen(item.id)}
                  aria-controls={`panel-${item.id}`}
                >
                  <div className="question">
                    <strong>{item.q}</strong>
                  </div>
                  <div className={`icon ${isOpen(item.id) ? "open" : ""}`}>
                    {isOpen(item.id) ? "−" : "+"}
                  </div>
                </div>
                <div
                  className="panel"
                  id={`panel-${item.id}`}
                  aria-hidden={!isOpen(item.id)}
                  style={{
                    maxHeight: isOpen(item.id) ? "200px" : "0px"
                  }}
                >
                  <p className="answer">{item.a}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Right column */}
          <div className="col">
            {faqs.slice(3).map((item) => (
              <div key={item.id} className="faq-card">
                <div
                  className="faq-toggle"
                  onClick={() => toggle(item.id)}
                  tabIndex="0"
                  role="button"
                  aria-expanded={isOpen(item.id)}
                  aria-controls={`panel-${item.id}`}
                >
                  <div className="question">
                    <strong>{item.q}</strong>
                  </div>
                  <div className={`icon ${isOpen(item.id) ? "open" : ""}`}>
                    {isOpen(item.id) ? "−" : "+"}
                  </div>
                </div>
                <div
                  className="panel"
                  id={`panel-${item.id}`}
                  aria-hidden={!isOpen(item.id)}
                  style={{
                    maxHeight: isOpen(item.id) ? "200px" : "0px"
                  }}
                >
                  <p className="answer">{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
